import React from 'react';

const WhoWeServePage = () => {
  const industries = [
    {
      title: 'Electronic Health Record Companies',
      subtitle: 'ONC-Certified EHR/EMR Compliance',
      icon: '🏥',
      gradient: 'from-blue-500 to-cyan-500',
      description: 'CareTap supports Electronic Health Records (EHRs) to comply with the ONC HTI-1 regulation. Our solutions help these organizations meet these requirements effectively and at a fraction of the cost it would take to do it on their own.',
    },
    {
      title: 'Medical Professionals/Physicians',
      subtitle: 'Patient Management Made Easy',
      icon: '👨‍⚕️',
      gradient: 'from-green-500 to-teal-500',
      description: 'Patient management and referrals made easier. Track current and past appointments with doctors and specialists. Quick access to important data and images greatly lowers the chance of misdiagnosis and repeated tests.',
    },
    {
      title: 'Health & Life Insurance Companies',
      subtitle: 'Streamline Claims Processing',
      icon: '🏛️',
      gradient: 'from-purple-500 to-pink-500',
      description: 'Insurance companies now have secure, on-demand access to verified health records. Whether checking claims or verifying patient data, insurers can streamline the claims process and gain accurate, real-time information for faster decision-making and improved operational efficiency.',
    },
    {
      title: 'Legal Firms',
      subtitle: 'Efficient Case Management',
      icon: '⚖️',
      gradient: 'from-orange-500 to-red-500',
      description: 'Our SaaS platform provides legal professionals confirmation of client medical history. Whether its malpractice claims or personal injury cases, we enable quick and reliable access to pertinent data, improving case management and outcomes.',
    },
    {
      title: 'Government & Corporations',
      subtitle: 'Data-Driven Public Health',
      icon: '🏢',
      gradient: 'from-indigo-500 to-blue-500',
      description: 'If the patient has given consent, you have actionable data at your fingertips that can save lives for First Responders and Law Enforcement Interactions.',
    },
  ];

  return (
    <div className="min-h-screen pt-20">
      <section className="relative py-20 bg-gradient-to-br from-blue-900 via-cyan-900 to-blue-900 text-white overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute inset-0" style={{ backgroundImage: 'radial-gradient(circle, white 1px, transparent 1px)', backgroundSize: '50px 50px' }} />
        </div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl md:text-6xl font-bold mb-6">Who We Serve</h1>
          <p className="text-xl md:text-2xl text-cyan-100 max-w-4xl mx-auto mb-8">With CareTap AI, patients can now view, manage and share their medical records no matter where services or imaging have taken place.</p>
          <p className="text-lg text-cyan-200 max-w-3xl mx-auto">Ensuring that all vital health profile is available when they need it most. Using their app, backed by CareTap AI's powerful SaaS Platform, the patient can now share their data, in near real time, to any of the following areas as needed.</p>
        </div>
      </section>

      <section className="py-20 bg-gradient-to-b from-gray-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="space-y-16">
            {industries.map((industry, index) => (
              <div key={index} className="bg-white rounded-2xl shadow-xl overflow-hidden hover:shadow-2xl transition-all duration-300">
                <div className={`bg-gradient-to-r ${industry.gradient} p-8 md:p-12`}>
                  <div className="flex items-center gap-6">
                    <div className="text-7xl bg-white/20 p-6 rounded-2xl backdrop-blur-sm">{industry.icon}</div>
                    <div className="flex-1">
                      <h2 className="text-3xl md:text-4xl font-bold text-white mb-2">{industry.title}</h2>
                      <p className="text-xl text-white/90 font-medium">{industry.subtitle}</p>
                    </div>
                  </div>
                </div>
                <div className="p-8 md:p-12">
                  <p className="text-gray-700 text-lg leading-relaxed">{industry.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-20 bg-gradient-to-r from-blue-600 to-cyan-500">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">Ready to Transform Your Industry?</h2>
          <p className="text-xl text-cyan-100 mb-8">Join leading organizations leveraging CareTap AI for better outcomes</p>
          <a href="mailto:info@caretapnexus.com" className="inline-block px-8 py-4 bg-white text-blue-600 rounded-full font-semibold text-lg hover:shadow-2xl hover:scale-105 transition-all duration-300">Contact Us Today</a>
        </div>
      </section>
    </div>
  );
};

export default WhoWeServePage;
